import { Button, Icon } from '@polyseme/design-system';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import Link from 'next/link';

import { images } from '~/landing/assets';
import { SUBSCRIBE_LINK } from '~/landing/core/links';

export const SubscribeTab = () => {
  const t = useTranslations('landing.retraite.contactCard.tabs.subscribe');

  const steps = [
    { key: 'informations', icon: 'circle-user' },
    { key: 'discovery', icon: 'sparkles' },
    {
      key: 'validation',
      icon: 'clipboard-check',
    },
    {
      key: 'done',
      icon: 'rocket',
    },
  ] as const;

  return (
    <div className="flex w-full flex-col gap-6">
      <div className="relative overflow-hidden rounded-lg">
        <div className="relative h-48 md:h-64">
          <Image
            fill
            priority
            alt=""
            className="object-cover brightness-90"
            src={images.retraite.contact}
          />
          <div className="absolute inset-0 bg-black/40" />
          <div className="absolute bottom-6 left-6 text-white">
            <h2 className="mb-2 text-xl font-bold md:text-2xl">
              {t('hero.title')}
            </h2>
            <p className="text-sm opacity-90 md:text-base">
              {t('hero.subtitle', {
                stepCount: String(steps.length),
              })}
            </p>
          </div>
        </div>
      </div>
      <ol className="flex flex-col gap-6">
        {steps.map(({ icon, key }, index) => (
          <li key={key} className="flex items-center gap-4">
            <div className="bg-brand-background text-brand grid size-8 place-items-center rounded-md">
              <Icon name={icon} />
            </div>
            <p>{`${index + 1}.  ${t(`steps.${key}`)}`}</p>
          </li>
        ))}
      </ol>
      <Button asChild className="w-full md:mx-auto md:w-[unset]">
        <Link href={SUBSCRIBE_LINK}>
          {t('cta')}
          <Icon name="coins" />
        </Link>
      </Button>
    </div>
  );
};
